import React, { Component } from 'react';
import './style.scss'
import PropTypes from 'prop-types';
import { Table, Tag, Popconfirm } from 'antd';
import {QuestionCircleOutlined, CloseOutlined, EyeOutlined} from '@ant-design/icons'

import { connect } from 'react-redux'
import { getStudents, deleteStudent, sendInvite } from './actions';
import {cloneDeep} from 'lodash';
import { showModal, MODAL_STUDENT_FORM, MODAL_STUDENT_FORM_VIEW } from '../../modules/modals';
import {toastr} from 'react-redux-toastr'

class Students extends Component {
  static contextTypes = {formatMessage: PropTypes.any}

  constructor(props) {
    super(props)
    this.state = {
      students_data: props.students,
			pageSize: 10,
			currentPage: 1,
			students: this.paginate(props.students, 10, 1),
    }
  }
  
  async componentDidMount(){
    try {
      await this.props.getStudents();
    } catch (error) {
      
    }
    
  }

  componentWillReceiveProps(nextProps){
    this.setState({
      students_data: nextProps.students,
      students: this.paginate(nextProps.students, this.state.pageSize, this.state.currentPage),
    })
  }

  paginate = (array, page_size, page_number) => {
		--page_number;
		return cloneDeep(array).slice(page_number * page_size, (page_number + 1) * page_size);
  }
  
  onShowSizeChange = (current, pageSize) => {
		this.setState({
			students: this.paginate(this.state.students_data, pageSize, current),
			pageSize,
			currentPage: current
		})
  }
  
  scrollToTop() {
    window.scrollTo( 0, 0 );
  }
  
  sendInvite = async (student_id) => {
    const {formatMessage} = this.context;
    try {
      await sendInvite({student_id});
      toastr.success(formatMessage('msgSuccessSendInviteTitle'), formatMessage('msgSuccessSendInvite'))
    } catch (error) {
      toastr.error('Error', formatMessage('msgErrorSendInvite'))
    }
  }

  render() {
    const {formatMessage} = this.context;
    const {students, pageSize, students_data, currentPage} = this.state;
    const {loaded} = this.props;
    console.log("🚀 ~ file: index.jsx ~ line 72 ~ Students ~ render ~ loaded", loaded)
    
    const columns = [
      {
        title: formatMessage('tableStudentNumber'),
        dataIndex: 'number',
        key: 'number',
      },
      {
        title: formatMessage('tableStudentFirstName'),
        dataIndex: 'firstname',
        key: 'firstname',
      },
      {
        title: formatMessage('tableStudentLastName'),
        dataIndex: 'lastname',
        key: 'lastname',
      },
      {
        title: formatMessage('tableStudentEmail'),
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: formatMessage('tableStudentInvitationStatus'),
        key: 'invite',
        render: (item) => 
          <Tag color={ item.password_hash ? 'green' : 'volcano'}>
            {item.password_hash ? 'Accepted' : 'Pending'}    
          </Tag>
        ,
      },
      {
        title: '',
        render: (item) => {
          return <div className="actions">
            {!item.password_hash ? <i onClick={() => {this.sendInvite(item.id)}} className="icon far fa-envelope"></i> : null}
            <EyeOutlined onClick={() => {
              const { showModal } = this.props;
              showModal({
                modalType : MODAL_STUDENT_FORM_VIEW,
                modalProps : {
                  student: item
                }
              });
            }} />
            <Popconfirm
              title={formatMessage('msgDeleteStudent')}
              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
              onConfirm={() => {
                this.props.deleteStudent(item.id);
              }}
            >
              <CloseOutlined />
            </Popconfirm>
            </div>;
        }
      },
    ];
    return (
      <div className="qbm-content StudentsPage">
        <div className="question-container ">
          <div className="question-types-block">
            <div className="btn-actions">
              <div className="question-type" onClick={() => {
                const { showModal } = this.props;
                showModal({
                  modalType : MODAL_STUDENT_FORM,
                  modalProps : {
                    initialValues: {}
                  }
                });
              }}>
                <span className="question-type-plus-icon">+</span> {formatMessage('btnNewStudent')}
              </div>
              {/* <div className="question-type">
                <span className="question-type-plus-icon"></span> {formatMessage('btnImportStudents')}
              </div> */}
            </div>
            <div className="table-data">
              <Table 
                dataSource={students}
                columns={columns}
                bordered
                loading={!loaded}
                pagination={{
                  total: students_data.length,
                  pageSizeOptions: ['5', '10', '20', '50'],
                  showSizeChanger: true,
                  pageSize,
                  onShowSizeChange: this.onShowSizeChange,
                  onChange: (page, pageSize) => {
                    this.setState({
                      students: this.paginate(this.state.students_data, pageSize, page),
                      pageSize,
                      currentPage: page,
                    }, () => {
                      this.scrollToTop(500);
                    })
                  }
                }}
                rowKey={(item) => (`student-${item.id}`)}
                current={currentPage}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



const mapStateToProps = (state, ownProps) => ({
  students: state.students.list,
  loaded: state.students.loaded
})

const mapDispatchToProps = {
  getStudents,
  deleteStudent,
  showModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(Students)




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Students/index.jsx